var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdownFilter",on:{"mouseenter":function($event){return _vm.$emit('mouseenter')},"mouseleave":function($event){return _vm.$emit('mouseleave')}}},[_c('div',{staticClass:"dropdownFilter__title"},[_vm._v("\n    "+_vm._s(_vm.title)+": "),_c('b',[_vm._v(_vm._s(_vm.filter))])]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }